export const LOCALES = {
	ENGLISH: 'en-US',
	ALBANIAN: 'sq',
	ARABIC: 'ar-AE',
	GERMAN: 'de-DE',
	SPANISH: 'es-ES',
	MANDARIN: 'zh',
};
